export enum Actions {
  CONFIGURATION_IMPORTED = 'CONFIGURATION_IMPORTED',
  SHOW_BUILD_TIME = 'SHOW_BUILD_TIME',
  TOGGLE_VERSION_CHECK = 'TOGGLE_VERSION_CHECK',
  SHOW_FEED_IDENTIFIER = 'SHOW_FEED_IDENTIFIER',
  ALLOW_AUDIO_NOTIFICATIONS = 'ALLOW_AUDIO_NOTIFICATIONS',
  REFRESH_TIME = 'REFRESH_TIME',
  SHOW_BUILD_LABEL = 'SHOW_BUILD_LABEL',
  ALLOW_SYSTEM_NOTIFICATIONS = 'ALLOW_SYSTEM_NOTIFICATIONS',
  SET_MAX_PROJECTS = 'SET_MAX_PROJECTS',
  CLICK_TO_SHOW_MENU = 'CLICK_TO_SHOW_MENU',
  SHOW_PROGNOSIS = 'SHOW_PROGNOSIS',
  MESSAGE_ADDED = 'MESSAGE_ADDED',
  MESSAGE_REMOVED = 'MESSAGE_REMOVED',
  FEED_ADDED = 'FEED_ADDED',
  FEED_UPDATED = 'FEED_UPDATED',
  FEED_REMOVED = 'FEED_REMOVED',
  PROJECT_SELECTED = 'PROJECT_SELECTED',
  SET_SORT = 'SET_SORT',
  ADD_BACKUP = 'ADD_BACKUP',
  BACKUP_SET_AUTOMATIC_EXPORT = 'BACKUP_SET_AUTOMATIC_EXPORT',
  BACKUP_EXPORTED = 'BACKUP_EXPORTED',
  BACKUP_REMOVE = 'BACKUP_REMOVE',
  BACKUP_IMPORTED = 'BACKUP_IMPORTED',
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
}
